import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class CastawayIsland1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CASTAWAY_ISLAND1;
}

export default CastawayIsland1PoiTileEntity;
